<template>
<div>
  <!-- <q-btn
    icon="apps"
    to="/tools"
    flat round
    class="q-mx-sm"
    @click="_onClick"
  /> -->
  <q-btn icon="apps" flat dense round class="q-ml-sm q-mr-md" @click="showToolsDialog = true">
    <q-tooltip anchor="bottom right" self="top right">{{ $t('names.tools') }}</q-tooltip>
    <q-menu v-if="!$q.platform.is.mobile" max-width="400px" :offset="[0, 5]">
      <div class="no-wrap q-pa-md text-center">
        <div class="row text-center">
          <div
            v-for="tool in tools"
            :key="tool"
            class="q-pa-xs col-4 text-center"
          >
            <tools-item
              :name="tool"
              :tool="$config.tools[tool]"
            />
          </div>
        </div>
      </div>
    </q-menu>
  </q-btn>
  <q-dialog
    v-if="$q.platform.is.mobile"
    v-model="showToolsDialog"
  >
    <q-card style="min-width: 350px;">
      <q-card-section>
        <div class="no-wrap q-pa-md text-center">
          <div class="row text-center">
            <div
              v-for="tool in tools"
              :key="tool"
              class="q-pa-xs col-4 text-center"
            >
              <tools-item
                :name="tool"
                :tool="$config.tools[tool]"
              />
            </div>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</div>
</template>

<script>
import { QBtn, QDialog, QCard, QCardSection, QMenu, QTooltip } from 'quasar'
import ToolsItem from '../Home/ToolsItem.vue'

export default {
  components: {
    QBtn, QDialog, QCard, QCardSection, QMenu, ToolsItem, QTooltip
  },
  methods: {
    _onClick () {
      this.$store.commit('layout/sidebarOpen', true)
    }
  },
  data () {
    return {
      showToolsDialog: false
    }
  },
  computed: {
    tools () {
      return this.$config.layout.home.tools.filter(tool => {
        return !this.$config.tools[tool].supported || this.$config.tools[tool].supported.call(this, this.$config.tools[tool])
      })
    }
  }
}
</script>

<style>
</style>
